import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstVe1: [],
		ve1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 21,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, ve1){
			state.ve1 = ve1
			if (ve1)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.ve1 = null
		},
		setParamsDataTable(state, payload){
			state.lstVe1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, ve1tipo){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Goals/GoalTypes/Find/${ve1tipo}`)
			.then(response => {
				let ve1 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", ve1)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Goals/GoalTypes/Insert", store.state.ve1 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-metas")
				store.state.ve1 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Goals/GoalTypes/Update", store.state.ve1 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-metas")
				store.state.ve1 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Goals/GoalTypes/Delete/${store.state.ve1.ve1tipo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tipos-de-metas")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Goals/GoalTypes/FindList")
			.then(response => {
				let lstVe1 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstVe1 = lstVe1
				store.state.hasNext = lstVe1.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstVe1 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 21, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Goals/GoalTypes/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVe1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}